import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle, theme } from './styles/GlobalStyles';
import { AuthProvider } from './context/AuthContext';

// Components
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Corals from './pages/Corals';
import Fish from './pages/Fish';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Admin from './pages/Admin';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Application error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          textAlign: 'center',
          background: '#f8fdff',
          color: '#0d47a1'
        }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>
            Oops! Etwas ist schiefgelaufen
          </h1>
          <p style={{ marginBottom: '2rem', color: '#64748b' }}>
            Es ist ein unerwarteter Fehler aufgetreten. Bitte laden Sie die Seite neu.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#006994',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <AuthProvider>
          <Router>
            <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <Navigation />
              <main style={{ flex: 1 }}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/korallen" element={<Corals />} />
                  <Route path="/fische" element={<Fish />} />
                  <Route path="/kontakt" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route 
                    path="/admin" 
                    element={
                      <ProtectedRoute requireAdmin={true}>
                        <Admin />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="*" 
                    element={
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '50vh',
                        padding: '2rem',
                        textAlign: 'center'
                      }}>
                        <h1 style={{ fontSize: '3rem', marginBottom: '1rem', color: '#006994' }}>
                          404
                        </h1>
                        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#0d47a1' }}>
                          Seite nicht gefunden
                        </h2>
                        <p style={{ marginBottom: '2rem', color: '#64748b' }}>
                          Die gesuchte Seite existiert nicht oder wurde verschoben.
                        </p>
                        <button
                          onClick={() => window.location.href = '/'}
                          style={{
                            background: '#006994',
                            color: 'white',
                            border: 'none',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '1rem'
                          }}
                        >
                          Zur Startseite
                        </button>
                      </div>
                    } 
                  />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;

